export default "__VITE_ASSET__GPD107nI__"